<div class="collapsed-sidebar-hover" >
  <div class="hover-toggle">
    <button
      mat-icon-button
      class="toggle-btn"
      [style.background-color]="backgroundColorButton"
      (click)="toggleSidenav()"
      aria-label="Expand Sidebar"
      matTooltip="Expand Sidebar"
      matTooltipPosition="right"
    >
      <mat-icon>chevron_right</mat-icon>
    </button>
  </div>
</div>

<div >
     <div  class="sidebar" [class.collapsed]="!isSidenavOpen" style="margin-top:0%;display: flex;height: 87vh;width: 100%;background: white;overflow: auto;">
      <div style="width: 100%;padding:0 10px">
        <div class="sidebar-header">
    <!-- Collapse button -->
            <button
                mat-icon-button
                class="toggle-btn"
                (click)="toggleSidenav()"
                aria-label="Collapse Sidebar"
                matTooltip="Collapse Sidebar"
                matTooltipPosition="right"
                style="
                    width: 24px;
                    height: 24px;
                    align-items: center;
                    line-height: unset;
                    margin-top: 2%;
                    color: #505258;"
            >
                <mat-icon style="font-size: 24px;">menu_open</mat-icon>
            </button>
        </div>
         <div class="sideBarFilters" style="margin-top: 5%;">
            <h6 style="font-weight: 500;">Products</h6>
            <div class="horizontal-line"></div>
             <p-select
            [options]="productsDisplayed"
            placeholder="Product"
            [(ngModel)]="selectedProduct"
            [filter]="true"
             panelStyleClass="custom-pselect-panel"
         appendTo="body"
            class="filter-dd"
            optionLabel="name"
                [appendTo]="'self'"
            (onChange)="onProductSelected($event.value)" style="width: 100%!important;">
            </p-select>
         </div>
         <h6 style="font-weight: 500;margin-top: 10%;">Filters</h6>
         <div class="horizontal-line"></div>
          <mat-expansion-panel class="advanceFilterPannel" [expanded]="advancedSchema.length > 0" style="box-shadow: unset; border: 1px solid #dcdcdc;">
             <mat-expansion-panel-header style="padding: 0 10px;">
          <mat-panel-title style="display: block;">
            Advanced Filters
            <p style="margin:0;
            font-size: 12px;
            color: #6B6E76;">
           <span
              *ngIf="advancedSchema.length > 0"
            >
              {{ advancedSchema.length }} active
            </span>
            <span
              *ngIf="advancedSchema.length === 0"
            >
              None applied
            </span>
          </p>
          </mat-panel-title>
        </mat-expansion-panel-header>
        <div>
             <mat-form-field appearance="outline" class="full-width" style="width:100%;margin: 0;">
                 <mat-label>Add Field</mat-label>
                   <mat-select (selectionChange)="addAdvancedField($event.value)">
                     <mat-optgroup label="Product Info">
                            <mat-option
                            *ngFor="let f of allPossibleFields.slice(0, 4)"
                            [value]="f"
                            [disabled]="getAdvancedFieldByKey(f.key)"
                            >
                            {{ f.label }}
                            </mat-option>
                        </mat-optgroup>

                         <mat-optgroup label="Therapy Info">
                            <mat-option
                            *ngFor="let f of allPossibleFields.slice(4, 10)"
                            [value]="f"
                            [disabled]="getAdvancedFieldByKey(f.key)"
                            >
                            {{ f.label }}
                            </mat-option>
                        </mat-optgroup>

                          <mat-optgroup label="Administration">
                            <mat-option
                            *ngFor="let f of allPossibleFields.slice(10, 17)"
                            [value]="f"
                            [disabled]="getAdvancedFieldByKey(f.key)"
                            >
                            {{ f.label }}
                            </mat-option>
                        </mat-optgroup>

                        <mat-optgroup label="Literature Info">
                            <mat-option
                            *ngFor="let f of allPossibleFields.slice(17, 21)"
                            [value]="f"
                            [disabled]="getAdvancedFieldByKey(f.key)"
                            >
                            {{ f.label }}
                            </mat-option>
                        </mat-optgroup>

                        <mat-optgroup label="Governance">
                            <mat-option
                            *ngFor="let f of allPossibleFields.slice(21, 27)"
                            [value]="f"
                            [disabled]="getAdvancedFieldByKey(f.key)"
                            >
                            {{ f.label }}
                            </mat-option>
                        </mat-optgroup>

                        <mat-optgroup label="Device Info">
                            <mat-option
                            *ngFor="let f of allPossibleFields.slice(27)"
                            [value]="f"
                            [disabled]="getAdvancedFieldByKey(f.key)"
                            >
                            {{ f.label }}
                            </mat-option>
                        </mat-optgroup>

                   </mat-select>
             </mat-form-field>

              <form  [formGroup]="advancedForm" style="display: flex; flex-direction: column; gap: 0.5rem">
                 <ng-container *ngFor="let cfg of advancedSchema; let i = index">
                     <div class="advaceFilterFields" style="display: flex;">
                        <ng-container [ngSwitch]="cfg.type">
                             <!-- Text -->
                             <mat-form-field
                                *ngSwitchCase="'text'"
                                appearance="outline"
                                class="full-width"
                            >
                                <mat-label>{{ cfg.label }}</mat-label>
                                <input matInput [formControlName]="cfg.key" />
                            </mat-form-field>

                              <!-- Select -->
                                <mat-form-field
                                    *ngSwitchCase="'select'"
                                    appearance="outline"
                                    class="full-width"
                                >
                                    <mat-label>{{ cfg.label }}</mat-label>
                                    <mat-select [formControlName]="cfg.key">
                                    <mat-option *ngFor="let o of cfg.options" [value]="o">
                                        {{ o }}
                                    </mat-option>
                                    </mat-select>
                                </mat-form-field>
                                 <!-- Date -->
                                    <mat-form-field
                                        *ngSwitchCase="'date'"
                                        appearance="outline"
                                        class="full-width"
                                    >
                                        <mat-label>{{ cfg.label }}</mat-label>
                                        <input
                                        matInput
                                        [matDatepicker]="dp"
                                        [formControlName]="cfg.key"
                                        />
                                        <mat-datepicker-toggle
                                        matSuffix
                                        [for]="dp"
                                        ></mat-datepicker-toggle>
                                        <mat-datepicker #dp></mat-datepicker>
                                    </mat-form-field>
                        </ng-container>
                          <!-- Remove button -->
                            <button
                            mat-icon-button
                            color="warn"
                            (click)="removeAdvancedField(cfg.key)"
                            >
                            <mat-icon>delete</mat-icon>
                            </button>
                     </div>
                 </ng-container>
              </form>
              <div
            *ngIf="advancedFilters.length > 0"
            style="
              display: flex;
              flex-direction: column;
              gap: 0.5rem;
              margin-top: 1rem;
            "
          >

           <div
              *ngFor="let field of advancedSchema"
              style="
                display: flex;
                justify-content: space-between;
                background-color: #f1f1f1;
                padding: 6px 12px;
                border-radius: 12px;
                min-height: 32px;
                gap: 1rem;
                flex-wrap: nowrap;
              "
            >
             <div
                style="font-size: 13px; display: flex; flex-direction: column"
              >
                <!-- <strong>{{ field.label }}:</strong> -->
                <h5 style="font-size: 12px;
    margin-bottom: 2px;">{{ field.label }}:</h5>
                <ng-container
                  *ngIf="
                    isArray(advancedForm.get(field.key)?.value);
                    else singleValue
                  "
                >
                  <span style="white-space: pre-wrap; word-break: break-word">
                    {{ advancedForm.get(field.key)?.value?.join(", ") }}
                  </span>
                </ng-container>
                <ng-template #singleValue>
                  <span style="white-space: pre-wrap; word-break: break-word">
                    {{ advancedForm.get(field.key)?.value }}
                  </span>
                </ng-template>
              </div>
              <button
                mat-icon-button
                color="warn"
                (click)="removeAdvancedField(field.key)"
                style="height: 24px; width: 24px; min-width: 24px"
              >
                <mat-icon style="font-size: 18px">close</mat-icon>
              </button>
            </div>
          </div>

          <!-- No filters message -->
          <div
            *ngIf="advancedSchema.length === 0"
            style="font-size: 12px; color: #888; padding-top: 0.5rem"
          >
            No filters applied.
          </div>
        </div>
        <div
          style="
            position: sticky;
            bottom: 0;
            background: white;
            padding: 1rem 0 0 0;
            z-index: 10;
            border-top: 1px solid #eee;
          "
        >
          <div style="display: flex; gap: 1rem; width: 100%">
            <button
              class="popup gridColour btn btn-rounded-button z-depth-1 waves-effect waves-light text-capitalize"
              [style.background-color]="backgroundColorButton"
              [disabled]="advancedSchema.length === 0"
              style="font-size: 13px; padding: 3px 12px;font-size: 12px;
    padding: 3px 12px;min-height: 30px;"
              (click)="applyAdvancedFilters()"
            >
              Apply Advanced
            </button>

            <button
              class="popup gridColour btn btn-rounded-button z-depth-1 waves-effect waves-light text-capitalize"
              [style.background-color]="backgroundColorButton"
              style="font-size: 13px; padding: 3px 12px;font-size: 12px;
    padding: 3px 12px;min-height: 30px;"
              (click)="clearAllAdvancedFilters()"
            >
              Clear All
            </button>
          </div>
        </div>

    </mat-expansion-panel>
      </div>
    </div>
</div>